/** Conversion helpers for `<input type="date">` and `<input type="time">`. */

function pad(value: number): string {
  return `${value}`.padStart(2, "0");
}

/** yyyy-mm-dd in local time. */
export function toDateInput(ms: number): string {
  const date = new Date(ms);
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

/** HH:mm in local time. */
export function toTimeInput(ms: number): string {
  const date = new Date(ms);
  return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function dateInputToMs(value: string): number | null {
  if (!value) return null;
  const [year, month, day] = value.split("-").map(Number);
  if (!year || !month || !day) return null;
  return new Date(year, month - 1, day).getTime();
}

/** Combines a date and a time (both local) into an epoch timestamp. */
export function combineDateAndTime(date: string, time: string): number | null {
  const base = dateInputToMs(date);
  if (base === null) return null;
  const [hours, minutes] = (time || "00:00").split(":").map(Number);
  const value = new Date(base);
  value.setHours(hours || 0, minutes || 0, 0, 0);
  return value.getTime();
}

/** Rounds up to the next half hour — a friendlier default for new events. */
export function nextRoundTime(ms = Date.now()): number {
  const date = new Date(ms);
  date.setSeconds(0, 0);
  date.setMinutes(date.getMinutes() + (30 - (date.getMinutes() % 30)));
  return date.getTime();
}
